import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";

import { apiRequest, apiSuccess, apiFailure } from "./reportsSlice";

const buildQueryString = (params = {}) => {
    const query = new URLSearchParams(params).toString();
    return query ? `?${query}` : "";
};

function* handleApiRequest(action) {

    const {
        method = "GET",
        endpoint,
        query = {},
        body = {},
        callback,
    } = action.payload;
    try {

        const queryString = buildQueryString(query);
        const url = `${process.env.REACT_APP_API_BASE_URL}${endpoint}${queryString}`;

        let response;

        // FIXED SWITCH LOGIC WITH break
        switch (method) {
            case "POST":
                response = yield call(axios.post, url, body);
                break;
            case "PUT":
                response = yield call(axios.put, url, body);
                break;
            case "DELETE":
                response = yield call(axios.delete, url);
                break;
            default:
                response = yield call(axios.get, url);
        }

        const result = response?.data;

        // Store in Redux
        yield put(apiSuccess(result));

        // Callback returns actual API data
        if (callback) callback(result);

        return result;
    } catch (error) {
        const message = error.response?.data?.message || error.message;

        yield put(apiFailure(message));

        if (callback) callback({ error: true, message });

        return { error: true, message };
    }
}

export function* genericWatcher() {
    yield takeLatest(apiRequest.type, handleApiRequest);
}
